import React, { useContext } from 'react';

import { ShareHelper } from '../../helpers';
import { FeatureGatingContext, useEntitlement } from '../../contexts';
import { buildListingBroadcastMessage } from '../../listings/helpers';
import { storeCaption } from '../../waBroadcast/waBroadcastApi';
import { Button } from '../ui';

// Share to Broadcast was the only option of a one-item action menu, so it is a
// plain secondary Button now. Same quota check, same broadcast message.
export function ListingActionButton({ listing }) {
  const { checkFeatureQuota } = useContext(FeatureGatingContext);
  // "Share via WhatsApp" (key share_to_broadcast) — the only action, so the control goes with the plan.
  const canShare = useEntitlement('share_to_broadcast');

  const onShare = async () => {
    const allowed = await checkFeatureQuota(FeatureGatingContext.features.SHARE_WHATSAPP);
    if (!allowed) {
      return;
    }

    // The store's own template when it has one (Owner Admin → Message templates).
    ShareHelper.whatsapp(await storeCaption("listing", listing.id, buildListingBroadcastMessage(listing)));
  };

  if (!canShare) return null;

  return (
    <Button variant="secondary" size="sm" data-btn="listing-share" onClick={onShare}>
      Send via WhatsApp
    </Button>
  );
}
